import React from 'react';
import classNames from 'classnames';

type StepperProps = {
  currentStep: number;
  totalSteps: number;
  stepLabels?: string[];
};

const Stepper: React.FC<StepperProps> = ({ currentStep, totalSteps, stepLabels = [] }) => {
  return (
    <div className="flex justify-between gap-12">
      {Array.from({ length: totalSteps }, (_, index) => {
        const step = index + 1;
        const isCompleted = step < currentStep;
        const isCurrent = step === currentStep;

        return (
          <React.Fragment key={step}>
            {/* Step Circle */}
            <div className="grid gap-y-8 justify-items-center">
              <div
                className={classNames('flex items-center justify-center rounded-full typo-title-24 w-16 h-16', {
                  'surface-primary text-white': isCompleted || isCurrent,
                  'surface-active text-faded': !isCompleted && !isCurrent,
                })}>
                {step}
              </div>
              {stepLabels && <div className="text-center typo-text-14--bold">{stepLabels[index]}</div>}
            </div>

            {/* Connector Line */}
            {step < totalSteps && (
              <div className="flex-1 h-16 flex items-center">
                <div
                  className="flex-1 h-0 border-t-[2px]"
                  style={{
                    borderStyle: 'dashed',
                    borderColor: isCompleted ? 'var(--primary)' : 'var(--border-distinct)',
                  }}
                />
              </div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default Stepper;
